import { Progress, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import type { Progress as ProgressCounts } from "types/headsetReleaseTypes";
import { percentOf } from "./releaseFormat";

interface UpdateProgressProps {
  progress: ProgressCounts;
  started: boolean;
}

export function UpdateProgress({ progress, started }: UpdateProgressProps) {
  const { t } = useTranslation();
  const label = started
    ? t("headsetReleases.progress.headsets", {
        percent: percentOf(progress),
        done: progress.done,
        total: progress.total,
      })
    : t("headsetReleases.progress.notStarted.headsets", { total: progress.total });
  return (
    <Stack gap={4} miw={150}>
      <Progress value={percentOf(progress)} color="green" size="sm" aria-label={label} />
      <Text size="xs" c="dimmed" style={{ fontVariantNumeric: "tabular-nums" }}>
        {label}
      </Text>
    </Stack>
  );
}
